import styled from 'styled-components';

const Label = styled.label`
  font-size: ${({ theme }) => theme.fontSize03};
  color: ${({ theme }) => theme.colorText50};
  font-weight: ${({ theme }) => theme.fontWeightMedium};
  display: block;
`;

export default Label;
